const sampleStore = {
      language: "english",
      darkmode: false,
      sounds: true,
  }
  
  export default sampleStore;